import React, { Fragment, PureComponent } from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import SettingsCircle from '@material-ui/icons/SettingsOutlined'
import AddIcon from '@material-ui/icons/AddOutlined'
import AppBar from '@material-ui/core/AppBar'
import ArrowLeft from '@material-ui/icons/ArrowLeft'
import Badge from '@material-ui/core/Badge'
import Divider from '@material-ui/core/Divider/'
import Drawer from '@material-ui/core/Drawer'
import Hidden from '@material-ui/core/Hidden'
import IconButton from '@material-ui/core/IconButton'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import TitleIcon from '@material-ui/icons/CheckCircleOutline'
import MenuIcon from '@material-ui/icons/Menu'
import SvgIcon from '@material-ui/core/SvgIcon'
import Toolbar from '@material-ui/core/Toolbar'
import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import { withStyles, withTheme } from '@material-ui/core/styles'
import { Droppable } from 'react-beautiful-dnd'
import Settings from './Settings'
import AreaFilter from '../components/area/AreaFilter'
import { ConfirmDelete } from '../components/confirmation/Confirm'
import Housekeeping from '../components/housekeeping/Housekeeping'
import LOG from '../logging/Logger'
import { isMobile } from 'react-device-detect'

const showDrawerIfSpace = true

const drawerWidth = 300

const projectIconPath =
  'M19 3H14.82C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M12 3C12.55 3 13 3.45 13 4S12.55 5 12 5 11 4.55 11 4 11.45 3 12 3M7 7H17V5H19V19H5V5H7V7M12 17V15H17V17H12M12 11V9H17V11H12M8 12V9H7V8H9V12H8M9.25 14C9.66 14 10 14.34 10 14.75C10 14.95 9.92 15.14 9.79 15.27L8.12 17H10V18H7V17.08L9 15H7V14H9.25'

const styles = theme => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1
  },
  drawer: {
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      flexShrink: 0
    }
  },
  drawerPaper: {
    width: drawerWidth,
    overflowY: 'hidden'
  },
  drawerPaperTemp: {
    minWidth: drawerWidth,
    width: '50%',
    [theme.breakpoints.down('xs')]: {
      width: '100%'
    }
  },
  grow: {
    flexGrow: 1
  },
  input: {
    margin: theme.spacing(1),
    width: '25ch',
    [theme.breakpoints.up('sm')]: {
      width: '40ch'
    },
    [theme.breakpoints.up('md')]: {
      width: '60ch'
    }
  },
  menuButton: {
    marginRight: 20,
    [theme.breakpoints.up('md')]: {
      display: showDrawerIfSpace ? 'none' : ''
    }
  },
  toolbar: {
    ...theme.mixins.toolbar,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingRight: 0
    }
  },
  chevron: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar
  },
  spinner: {
    animation: '$spin infinite 1s linear'
  },
  '@keyframes spin': {
    from: {
      transform: 'rotate(0deg)'
    },
    to: {
      transform: 'rotate(360deg)'
    }
  },
  wrapper: {
    position: 'relative'
  },
  syncing: {
    position: 'absolute',
    top: -1,
    left: -1,
    zIndex: 1
  }
})

class Sidebar extends PureComponent {
  state = {
    mobileOpen: false,
    anchorEl: null,
    settingsState: false,
    openConfirmDeleteProject: false,
    showProjectTooltip: false, // Tootlips not always closing on mobile, when the drawer closes, handle them manually,
    openSettings: false
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.showSubscriptionPlans !== prevProps.showSubscriptionPlans &&
      this.props.showSubscriptionPlans
    ) {
      this.setState({ openSettings: true })
    }
  }

  handleClose = () =>
    this.setState({
      anchorEl: null
    })

  handleShowInbox = () => {
    this.handleClose()
    this.props.handleRedirect('/')
  }

  handleShowAccount = () => {
    this.handleClose()
    this.props.handleRedirect('/account')
  }

  handleShowProfile = () => {
    this.handleClose()
    this.props.handleRedirect('/profile')
  }

  handleShowSettings = () => {
    this.handleClose()
    this.setState({ openSettings: true })
    this.props.setShowSubscriptionPlans(false)
  }

  handleShowProject = id => {
    this.setState(state => ({ mobileOpen: false }))
    this.props.handleRedirect('/project/' + id)
  }

  handleCreateProject = () => {
    const projectPromise = this.props.createProject('New Project')
    if (projectPromise instanceof Promise) {
      projectPromise
        .then(project => {
          if (project && project.id) {
            this.handleShowProject(project.id)
          }
        })
        .catch(error => {
          console.error('Failed to create project:', error)
        })
    }
  }

  handleDrawerToggle = () => {
    this.setState(state => ({
      mobileOpen: !state.mobileOpen,
      showProjectTooltip: false
    }))
  }

  handleDeleteProject = project => {
    this.setState({ openConfirmDeleteProject: project })
  }

  render() {
    LOG.debug('Render: Navigation: Sidebar')

    const { theme, classes } = this.props,
      { anchorEl } = this.state

    const onNavigationSelect = item => {
      this.setState(state => ({ mobileOpen: false }))

      this.props.handleSelect(item)
    }

    const getTodoCount = item => {
      const { list, futureList, count: wantCount = true } = item

      let count = 0

      if (wantCount) {
        list &&
          list.split(',').forEach(listItem => {
            count += this.props.getOutstandingTodoListCount(
              listItem,
              true,
              false
            )
          })

        futureList &&
          futureList.split(',').forEach(listItem => {
            count += this.props.getOutstandingTodoListCount(
              listItem,
              false,
              true
            )
          })
      }

      return count > 0 ? count : null
    }

    const filterNavigation = position => {
      if (this.props.navigation) {
        return this.props.navigation.filter(item => {
          return (
            (item.sidebar === undefined || item.sidebar) &&
            (item.position === position ||
              (!item.position && position === 'top'))
          )
        })
      }
      return []
    }

    const listItem = item => {
      const todoCount = getTodoCount(item)

      return (
        <Fragment>
          {item.image && (
            <ListItemIcon>
              <Fragment>
                {todoCount && (
                  <Badge color='primary' badgeContent={todoCount} max={999}>
                    {item.image.icon}
                    {item.image.path && (
                      <SvgIcon color={item.image.colour}>
                        <path d={item.image.path} />
                      </SvgIcon>
                    )}
                  </Badge>
                )}
                {!todoCount && (
                  <Fragment>
                    {item.image.icon}
                    {item.image.path && (
                      <SvgIcon color={item.image.colour}>
                        <path d={item.image.path} />
                      </SvgIcon>
                    )}
                  </Fragment>
                )}
              </Fragment>
            </ListItemIcon>
          )}
          <ListItemText id={item.id} primary={item.title} />
        </Fragment>
      )
    }

    const navigationSection = position => {
      return (
        <Fragment>
          {filterNavigation(position).map(item => (
            <Fragment key={item.id}>
              {item.dividerPre && <Divider />}

              {item.list && item.list.split(',').length === 1 && (
                <Droppable
                  droppableId={'nav:' + item.list}
                  isCombineEnabled={true}
                >
                  {(provided, snapshot) => (
                    <ListItem
                      ref={provided.innerRef}
                      style={{
                        backgroundColor: snapshot.isDraggingOver
                          ? theme.palette.primary.main
                          : null
                      }}
                      button
                      selected={
                        item.id === this.props.navigationSelectedItem.id
                      }
                      onClick={event => {
                        LOG.debug('Navigating to', item.id)
                        onNavigationSelect(item)
                      }}
                    >
                      {listItem(item)}

                      {provided.placeholder}
                    </ListItem>
                  )}
                </Droppable>
              )}
              {(!item.list || item.list.split(',').length > 1) && (
                <ListItem
                  button
                  selected={item.id === this.props.navigationSelectedItem.id}
                  onClick={event => {
                    LOG.debug('Navigating to', item.id)
                    onNavigationSelect(item)
                  }}
                >
                  {listItem(item)}
                </ListItem>
              )}
              {item.dividerPost && <Divider />}
            </Fragment>
          ))}
        </Fragment>
      )
    }

    const getHighlightColour = project => {
      if (project.area) {
        const area = this.props.getAreaById(project.area)
        if (area && area.colour) {
          return area.colour
        }
      }
      return theme.palette.primary.main
    }

    const drawer = (
      <Fragment>
        <List style={{ overflowY: 'auto' }}>
          {navigationSection('top')}
          <Divider />
          {this.props.getProjects().map((project, index) => (
            <Droppable
              key={project.id}
              droppableId={'project:' + project.id}
              isCombineEnabled={true}
            >
              {(provided, snapshot) => (
                <Fragment>
                  <Tooltip
                    title={this.props.decrypt(project.name)}
                    open={
                      this.state.showProjectTooltip !== false &&
                      this.state.showProjectTooltip[project.id] === true
                    }
                    onOpen={() =>
                      this.setState({
                        showProjectTooltip: {
                          [project.id]: true
                        }
                      })
                    }
                    onClose={() =>
                      this.setState({
                        showProjectTooltip: { [project.id]: false }
                      })
                    }
                  >
                    <ListItem
                      ref={provided.innerRef}
                      style={{
                        backgroundColor: snapshot.isDraggingOver
                          ? theme.palette.primary.main
                          : null
                      }}
                      selected={
                        project.id === this.props.navigationSelectedItem.id
                      }
                      onClick={event => this.handleShowProject(project.id)}
                      button
                    >
                      <ListItemIcon>
                        <SvgIcon style={{ color: getHighlightColour(project) }}>
                          <path d={projectIconPath} />
                        </SvgIcon>
                      </ListItemIcon>
                      <ListItemText
                        primary={this.props.decrypt(project.name)}
                        primaryTypographyProps={{ noWrap: true }}
                      />
                    </ListItem>
                  </Tooltip>
                  {provided.placeholder}
                </Fragment>
              )}
            </Droppable>
          ))}
          <ListItem button onClick={event => this.handleCreateProject()}>
            <ListItemIcon>
              <AddIcon />
            </ListItemIcon>
            <ListItemText primary='Add Project' />
          </ListItem>
          <Divider />
          {navigationSection('bottom')}
        </List>
        <ConfirmDelete
          open={this.state.openConfirmDeleteProject !== false}
          deleteItem={this.props.decrypt(
            this.state.openConfirmDeleteProject.name
          )}
          onOk={async () => {
            await this.props.deleteProject(this.state.openConfirmDeleteProject)
            this.setState({ openConfirmDeleteProject: false })
          }}
          onCancel={() => this.setState({ openConfirmDeleteProject: false })}
        />
      </Fragment>
    )

    const toggleDrawer = event => {
      if (
        event &&
        event.type === 'keydown' &&
        (event.key === 'Tab' || event.key === 'Shift')
      ) {
        return
      }

      this.setState(state => ({
        openSettings: !state.openSettings
      }))
      this.props.setShowSubscriptionPlans(false)
    }

    return (
      <Fragment>
        <AppBar position='fixed' color='primary' className={classes.appBar}>
          <Toolbar className={classes.toolbar}>
            <IconButton
              color='inherit'
              aria-label='Open drawer'
              onClick={this.handleDrawerToggle}
              className={classes.menuButton}
            >
              <MenuIcon />
            </IconButton>
            <Hidden smDown>
              <TitleIcon />
            </Hidden>
            <Hidden smDown>
              <Typography variant='h6' color='inherit' className={classes.grow}>
                &nbsp;Getting Focused
              </Typography>
            </Hidden>
            <Hidden mdUp>
              <div className={classes.grow} />
            </Hidden>
            <AreaFilter
              getAreaFilter={this.props.getAreaFilter}
              updateAreaFilter={this.props.updateAreaFilter}
              getAreas={this.props.getAreas}
              createArea={this.props.createArea}
              deleteArea={this.props.deleteArea}
              editArea={this.props.editArea}
              decrypt={this.props.decrypt}
              navigationSelectedItem={this.props.navigationSelectedItem}
              openAreaFilter={this.props.openAreaFilter}
              setOpenAreaFilter={this.props.setOpenAreaFilter}
            />
            <div className={classes.grow} />
            <Housekeeping
              classes={{
                iconOuter: classes.wrapper,
                iconInner: classes.warning
              }}
              getTodos={this.props.getTodos}
              deleteTodo={this.props.deleteTodo}
              moveTodoToTrash={this.props.moveTodoToTrash}
            />
            <IconButton
              aria-owns={anchorEl ? 'menu-appbar' : undefined}
              aria-haspopup='true'
              onClick={() => this.handleShowSettings()}
              color='inherit'
            >
              <Tooltip
                title={
                  this.props.isCallingBackend
                    ? 'Storing Locally'
                    : this.props.isSyncing
                    ? this.props.isOffline
                      ? 'Offline'
                      : 'Syncing'
                    : 'Settings'
                }
                disableFocusListener={isMobile}
              >
                <div className={classes.wrapper}>
                  <SettingsCircle
                    className={
                      this.props.isCallingBackend ? classes.spinner : null
                    }
                  />
                  {this.props.isSyncing && (
                    <CircularProgress
                      style={{
                        color: this.props.isOffline
                          ? theme.palette.secondary.main
                          : theme.palette.primary.contrastText
                      }}
                      size={'1.62rem'}
                      thickness={2}
                      className={classes.syncing}
                    />
                  )}
                </div>
              </Tooltip>
            </IconButton>
          </Toolbar>
        </AppBar>

        {showDrawerIfSpace && (
          <Fragment>
            <Hidden mdUp>
              <Drawer
                variant='temporary'
                className={classes.drawer}
                open={this.state.mobileOpen}
                onClose={this.handleDrawerToggle}
                classes={{
                  paper: classes.drawerPaperTemp
                }}
                ModalProps={{
                  keepMounted: true
                }}
                disableRestoreFocus={true}
              >
                <div className={classes.chevron}>
                  <IconButton onClick={this.handleDrawerToggle}>
                    <ArrowLeft />
                  </IconButton>
                </div>
                <Divider />
                {drawer}
              </Drawer>
            </Hidden>
            <Hidden smDown>
              <Drawer
                variant='permanent'
                className={classes.drawer}
                classes={{
                  paper: classes.drawerPaper
                }}
              >
                <Fragment>
                  <div className={classes.toolbar} />
                  {drawer}
                </Fragment>
              </Drawer>
            </Hidden>
          </Fragment>
        )}
        {!showDrawerIfSpace && (
          <Drawer
            variant='temporary'
            className={classes.drawer}
            open={this.state.mobileOpen}
            onClose={this.handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper
            }}
            ModalProps={{
              keepMounted: true
            }}
          >
            {drawer}
          </Drawer>
        )}

        <Drawer
          style={{ zIndex: theme.zIndex.drawer + 2 }}
          open={this.state.openSettings}
          onClose={toggleDrawer}
          ModalProps={{
            keepMounted: true
          }}
        >
          <Settings
            version={this.props.version}
            showPlans={this.props.showSubscriptionPlans}
            toggleDrawer={toggleDrawer}
            deleteAll={this.props.deleteAll}
            getExportableArea={this.props.getExportableArea}
            getExportableProject={this.props.getExportableProject}
            getExportableRepeat={this.props.getExportableRepeat}
            getExportableTag={this.props.getExportableTag}
            getExportableTodo={this.props.getExportableTodo}
            getAreas={this.props.getAreas}
            getUnfilteredProjects={this.props.getUnfilteredProjects}
            getProjects={this.props.getProjects}
            getRepeats={this.props.getRepeats}
            getTags={this.props.getTags}
            getUnfilteredTodos={this.props.getUnfilteredTodos}
            getTodos={this.props.getTodos}
            createFullTodo={this.props.createFullTodo}
            createProject={this.props.createProject}
            createArea={this.props.createArea}
            createRepeat={this.props.createRepeat}
            createTag={this.props.createTag}
            setInfo={this.props.setInfo}
            setError={this.props.setError}
            logout={this.props.logout}
            isOffline={this.props.isOffline}
            setShowSubscriptionPlans={this.props.setShowSubscriptionPlans}
          />
        </Drawer>
      </Fragment>
    )
  }
}

export default withTheme(withStyles(styles)(Sidebar))
